/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupContractMandatItemDto
 */
export interface GroupContractMandatItemDto {
    /**
     * 
     * @type {string}
     * @memberof GroupContractMandatItemDto
     */
    id: string;
    /**
     * Creditor name (insurance company — Tunnel.CompteBancaire.Personne.PersonneMorale.Designation).
     * @type {string}
     * @memberof GroupContractMandatItemDto
     */
    creditorName?: string | null;
    /**
     * Masked creditor IBAN for display (e.g. "FR76****1234").
     * @type {string}
     * @memberof GroupContractMandatItemDto
     */
    creditorIbanMasked?: string | null;
    /**
     * Products covered by this mandate (1 or more tunnels sharing the same creditor).
     * @type {Array<string>}
     * @memberof GroupContractMandatItemDto
     */
    productNames: Array<string>;
    /**
     * draft   → mandate created but not yet sent for signature.
     * pending → signature email sent, awaiting user signature on Epithete portal.
     * signed  → RUM received from Epithete, mandate locked.
     * 
     * @type {string}
     * @memberof GroupContractMandatItemDto
     */
    signatureStatus: GroupContractMandatItemDtoSignatureStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof GroupContractMandatItemDto
     */
    sentAt?: Date | null;
    /**
     * SEPA mandate unique reference, set when signed.
     * @type {string}
     * @memberof GroupContractMandatItemDto
     */
    rum?: string | null;
}


/**
 * @export
 */
export const GroupContractMandatItemDtoSignatureStatusEnum = {
    Draft: 'draft',
    Pending: 'pending',
    Signed: 'signed'
} as const;
export type GroupContractMandatItemDtoSignatureStatusEnum = typeof GroupContractMandatItemDtoSignatureStatusEnum[keyof typeof GroupContractMandatItemDtoSignatureStatusEnum];


/**
 * Check if a given object implements the GroupContractMandatItemDto interface.
 */
export function instanceOfGroupContractMandatItemDto(value: object): value is GroupContractMandatItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('productNames' in value) || value['productNames'] === undefined) return false;
    if (!('signatureStatus' in value) || value['signatureStatus'] === undefined) return false;
    return true;
}

export function GroupContractMandatItemDtoFromJSON(json: any): GroupContractMandatItemDto {
    return GroupContractMandatItemDtoFromJSONTyped(json, false);
}

export function GroupContractMandatItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupContractMandatItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creditorName': json['creditorName'] == null ? undefined : json['creditorName'],
        'creditorIbanMasked': json['creditorIbanMasked'] == null ? undefined : json['creditorIbanMasked'],
        'productNames': json['productNames'],
        'signatureStatus': json['signatureStatus'],
        'sentAt': json['sentAt'] == null ? undefined : (new Date(json['sentAt'])),
        'rum': json['rum'] == null ? undefined : json['rum'],
    };
}

export function GroupContractMandatItemDtoToJSON(json: any): GroupContractMandatItemDto {
    return GroupContractMandatItemDtoToJSONTyped(json, false);
}

export function GroupContractMandatItemDtoToJSONTyped(value?: GroupContractMandatItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'creditorName': value['creditorName'],
        'creditorIbanMasked': value['creditorIbanMasked'],
        'productNames': value['productNames'],
        'signatureStatus': value['signatureStatus'],
        'sentAt': value['sentAt'] == null ? undefined : ((value['sentAt'] as any).toISOString()),
        'rum': value['rum'],
    };
}

